var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14.87,
    viewBox: "0 0 22 14.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 7.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 -7.435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.946,0H3.054A3.054,3.054,0,0,0,0,3.054v8.761A3.054,3.054,0,0,0,3.054,14.87H18.946A3.054,3.054,0,0,0,22,11.815V3.054A3.054,3.054,0,0,0,18.946,0ZM20.08,11.928a1.022,1.022,0,0,1-1.022,1.022H2.942A1.022,1.022,0,0,1,1.92,11.928V2.942A1.022,1.022,0,0,1,2.942,1.92H19.058A1.022,1.022,0,0,1,20.08,2.942Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.643,
    height: 4.814,
    transform: "translate(7.679 3.276)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.914,
    cy: 0.914,
    r: 0.914,
    transform: "translate(17.742 9.32)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.213,
    cy: 0.213,
    rx: 0.213,
    ry: 0.213,
    transform: "translate(3.052 7.587)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.213,
    cy: 0.213,
    rx: 0.213,
    ry: 0.213,
    transform: "translate(3.052 8.707)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/devices-icon.1588ea49c3215874b99587ff23ad52d9.svg";
export { ForwardRef as ReactComponent };